type ElementosCorreo = {
  saludo: string;
  slogan1: string;
  slogan2: string;
};

type Cotizacion = {
  archivos_adjuntos: any[];
  ayudantes: number;
  clave: number;
  cotizacion_pdf: string;
  descuento_porcentaje: number;
  enviado_correo: number;
  esta_creada: boolean;
  horas: string;
  id_mm: number;
  precio: string | number;
  tipo_precio: 'exclusiva';
  unidad_cambiada: number;
  vehiculo: string | null;
  nota_adicional: string;
  elementos_correo: ElementosCorreo;
};

type CotizacionCompartida = {
  archivos_adjuntos: any[];
  ayudantes: number;
  clave: number;
  cotizacion_pdf: string;
  descuento_porcentaje: number;
  elementos_correo: Record<string, unknown>;
  enviado_correo: number;
  horas: string;
  id_mm: number;
  id: number;
  nota_adicional: string;
  precio: string | number;
  tipo_precio: 'compartida';
  vehiculo: string | null;
};

const cotizacion: Cotizacion = {
  archivos_adjuntos: [],
  ayudantes: 1,
  clave: 0,
  cotizacion_pdf: '',
  descuento_porcentaje: 0,
  enviado_correo: 0,
  esta_creada: false,
  horas: '2',
  id_mm: 0,
  precio: '',
  tipo_precio: 'exclusiva',
  unidad_cambiada: 0,
  vehiculo: null,
  nota_adicional: '',
  elementos_correo: {
    saludo: '',
    slogan1: '',
    slogan2: '',
  },
};

const cotizacion_compartida: CotizacionCompartida = {
  archivos_adjuntos: [],
  ayudantes: 1,
  clave: 0,
  cotizacion_pdf: '',
  descuento_porcentaje: 0,
  elementos_correo: {},
  enviado_correo: 0,
  horas: '7 días',
  id_mm: 0,
  id: 0,
  nota_adicional: '',
  precio: '',
  tipo_precio: 'compartida',
  vehiculo: null,
};

function get_cotizacion(id_mm = 0): Cotizacion {
  const c: Cotizacion = JSON.parse(JSON.stringify(cotizacion));
  c.id_mm = id_mm;
  return c;
}

function get_cotizacion_compartida(id_mm = 0): CotizacionCompartida {
  const c: CotizacionCompartida = JSON.parse(JSON.stringify(cotizacion_compartida));
  c.id_mm = id_mm;
  return c;
}

export {
  cotizacion,
  cotizacion_compartida,
  get_cotizacion,
  get_cotizacion_compartida,
};
